module.exports = ".boxedLookup ::ng-deep div.ng-value {\n    white-space: nowrap !important;\n}"